import { AnimatePresence, motion } from 'framer-motion';

import { Photo } from '../Photo/Photo';

import styles from './Message.module.css';
import logo from '../../assets/images/logo.png';

const Message = ({ currentMessage, message, rotateSign, duration }) => {
  const durationSec = duration / 1000;
  const endpointStart = 0.33;
  const exitDuration = 0.18 * durationSec;
  const allStartDuration = durationSec - exitDuration;
  const startDutation = allStartDuration * endpointStart;

  return (
    <div className={styles.wrapper}>
      <motion.div
        className={styles.logoBlock}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img src={logo} alt="" className={styles.logo} />
      </motion.div>

      <AnimatePresence mode="wait">
        <motion.div
          key={currentMessage.id}
          initial={{ scale: 0 }}
          animate={{
            scale: [0, 1, 0.9],
            transition: {
              duration: allStartDuration,
              times: [0, endpointStart, 1],
            },
          }}
          exit={{
            y: '-100vh',
            transition: {
              duration: exitDuration,
            },
          }}
          className={styles.photoBlock}
        >
          <Photo
            message={message}
            rotateSign={rotateSign}
            startDutation={startDutation}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Message;
